import React from 'react';
import { object, func, array } from 'prop-types';

import UserListItem from './user-list-item';
import { USER_ROLES } from '../../../api/constants';

import {
  ListUsersWrapper,
  ListUsersContainer,
} from './styled-components';

const { ADMIN, SUPER_ADMIN, USER } = USER_ROLES;


const additionalUserActions = (authorizedUser, { role, isActivated, isDeleted }) => ({
  canArchive:
    (authorizedUser.role === ADMIN &&
      role !== ADMIN &&
      role !== SUPER_ADMIN &&
      isActivated) ||
    (authorizedUser.role === SUPER_ADMIN &&
      role !== SUPER_ADMIN &&
      isActivated),
  canRestore:
    (authorizedUser.role === SUPER_ADMIN &&
      isDeleted),
  canReInvite:
    (authorizedUser.role === SUPER_ADMIN &&
      !isDeleted &&
      !isActivated) ||
    (authorizedUser.role === ADMIN &&
      role !== ADMIN &&
      !isDeleted &&
      !isActivated),
  canCancelInvite:
    (authorizedUser.role === SUPER_ADMIN &&
      !isDeleted &&
      !isActivated) ||
    (authorizedUser.role === ADMIN &&
      role !== ADMIN &&
      !isDeleted &&
      !isActivated),
  canPromoteToAdmin:
    (authorizedUser.role === SUPER_ADMIN &&
      role === USER &&
      isActivated),
});


const ListUsers = ({
  users,
  authorizedUser,
  reInviteUser,
  onDeleteUser,
  onRestoreUser,
  onChangeUserRole,
  onCancelInvitation,
}) => (
  <ListUsersWrapper>
    <ListUsersContainer>
      {users.map(user => (
        <UserListItem
          user={user}
          key={user._id}
          reInviteUser={reInviteUser}
          onDeleteUser={onDeleteUser}
          onRestoreUser={onRestoreUser}
          onChangeUserRole={onChangeUserRole}
          onCancelInvitation={onCancelInvitation}
          authorizedUserActions={additionalUserActions(authorizedUser, user)}
        />
      ))}
    </ListUsersContainer>
  </ListUsersWrapper>
);

ListUsers.propTypes = {
  users: array.isRequired,
  authorizedUser: object.isRequired,
  reInviteUser: func.isRequired,
  onDeleteUser: func.isRequired,
  onRestoreUser: func.isRequired,
  onChangeUserRole: func.isRequired,
  onCancelInvitation: func.isRequired,
};

export default ListUsers;



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/list-users/list-users-comp.js